<template>
  <section id="external_section" class="relative py-20 pb-48 bg-gray-300">
    <div
      class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
      style="height: 80px; transform: translateZ(0px);"
    >
      <angled-s-v-g colorClass="text-gray-300"></angled-s-v-g>
    </div>

    <div class="container mx-auto px-4">
      <div class="items-center flex flex-wrap">
        <div class="w-full md:w-5/12 ml-auto mr-auto px-4">
          <div class="md:pr-12">
            <div
              class="p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full"
            >
              <i class="fa fa-user-friends"></i>
            </div>
            <h3 class="text-3xl font-semibold">Verstärken Sie Ihr Team</h3>
            <p class="mt-4 text-lg leading-relaxed text-gray-600">
              Fehlen Ihnen Ressourcen oder das notwendige Know-How, um Ihr IT-Projekt fertigzustellen?
              Unsere Engineers unterstützen Sie bei Ihrem Projekt, per Remote oder auch bei Ihnen vor Ort.
            </p>
           <p class="pt-6"><a href="#contactForm" v-smooth-scroll>Skalieren Sie Ihr Team und nehmen Sie unverbindlich mit uns Kontakt auf.</a></p>
          </div>
        </div>
        <div class="w-full md:w-4/12 ml-auto mr-auto px-4">
          <img
            alt="..." 
            src="../assets/img/external.jpg"
            srcset="../assets/img/external_small.jpg 480w, ../assets/img/external.jpg 800w"
            sizes="(max-width: 600px) 480px, 800px"
            class="w-full align-middle rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AngledSVG from "../components/Base/AngledSVG.vue";
export default {
  components: {
    AngledSVG
  }
};
</script>

<style>
</style>